import React from 'react';
import { InventoryLayout } from '../components/inventory/InventoryLayout';
export function CookiePolicyPage() {
  return <InventoryLayout data-id="element-397">
      {/* Page Header */}
      <div className="bg-navy-900 py-12 sm:py-16 border-b border-white/10" data-id="element-398">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-399">
          <div className="border-l-4 border-cg-orange-600 pl-6" data-id="element-400">
            <h1 className="text-3xl md:text-5xl font-bold text-white leading-tight" data-id="element-401">
              Cookie Policy
            </h1>
          </div>
        </div>
      </div>

      <section className="bg-white py-16 sm:py-24" data-id="element-402">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-lg text-steel-600" data-id="element-403">
          <p data-id="element-404">Last updated: February 2025</p>
          <h3 data-id="element-405">What Are Cookies?</h3>
          <p data-id="element-406">
            Cookies are small text files that are placed on your computer or
            mobile device by websites that you visit. They are widely used in
            order to make websites work, or work more efficiently, as well as to
            provide information to the owners of the site.
          </p>
          <h3 data-id="element-407">How We Use Cookies</h3>
          <p data-id="element-408">Chiltern Global uses cookies to:</p>
          <ul data-id="element-409">
            <li data-id="element-410">
              Understand how you use our website (e.g. which pages you visit).
            </li>
            <li data-id="element-411">Remember your preferences.</li>
            <li data-id="element-412">Improve your experience on our site.</li>
          </ul>
          <h3 data-id="element-413">Managing Cookies</h3>
          <p data-id="element-414">
            Most web browsers allow some control of most cookies through the
            browser settings. To find out more about cookies, including how to
            see what cookies have been set and how to manage and delete them,
            visit www.aboutcookies.org or www.allaboutcookies.org.
          </p>
        </div>
      </section>
    </InventoryLayout>;
}